import React, { FC } from 'react';
import * as yup from 'yup';
import { emailRequired } from 'global/utils/validation';
import logo from 'assets/logo.png';
import { FormikInput } from 'common/form';
import { Formik, Form } from 'formik';
import { Panel, SendButton } from 'pages/user/components';
import { EmailFormProps } from './email-form.types';

export const EmailForm: FC<EmailFormProps> = ({
  isLoading = false,
  onSignIn,
  remoteValidationError,
  resetRemoteValidatorError,
}) => (
  <Formik
    initialValues={{ email: '' }}
    validationSchema={yup.object().shape({ email: emailRequired() })}
    onSubmit={values => onSignIn(values.email)}>
    <Panel>
      <img alt="logo" src={logo} />
      <span>Ingrese su correo electrónico. Le enviaremos un enlace seguro para acceder.</span>
      <Form className="w-full">
        <FormikInput
          name="email"
          suffix={<SendButton isLoading={isLoading} />}
          type="email"
          wrapperClassName="w-full"
          onBlur={() => resetRemoteValidatorError?.()}
        />
        {remoteValidationError && <p className="text-sm text-red-600 text-left">{remoteValidationError}</p>}
      </Form>
    </Panel>
  </Formik>
);
